<template lang="html">
    <!--<div class="page-container" v-if="specialist">-->
    <div class="page-container">
        <UiButton name="Programează-te" :class="[{'new-appointment': true}]" @click="bookingModalOpen"
            v-if="user.role === 'client' && specialist && specialist.timetable" :disabled="specialist && (!specialist.available)" />
        <div class="page-container__body">
            <div class="profile-grid">
                <div class="profile-grid__column">
                    <Card title="Profil">
                        <Profile v-if="specialist" @toggleMediaModal="showMediaModal = !showMediaModal"/>
                        <Profile v-else :skeleton="true" />
                    </Card>
                    <div class="spacer timetable__mobile"></div>
                    <Card title="Programări" class="timetable__mobile" v-if="specialist">
                        <div v-if="specialist && (!specialist.available)"
                            style="font-size: 13px; line-height: 1.5; text-align: center; margin-top: 20px;">
                            Programările au fost temporar dezactivate de către specialist.
                        </div>
                        <TimetableDisplay v-else-if="specialist" />
                        <div class="appointments__user-services" v-if="this.userServices.length == 1">
                            <i class="fas fa-info-circle"> </i> Ai <span> o ședință </span> disponibilă la acest
                            specialist.
                        </div>
                        <div class="appointments__user-services" v-if="this.userServices.length > 1">
                            <i class="fas fa-info-circle"> </i> Ai <span> {{this.userServices.length}} ședințe </span> disponibile
                            la acest specialist.
                        </div>
                        
                        <div class="appointments">
                            <UiButton name="Ședință acum"
                                :class="[{'appointments__action': true}]" :anytime="true"
                                :disabled="specialist && (!specialist.overtime) || (anytimeWidget && anytimeWidget.meeting)"
                                v-if="user.role === 'client' && specialist && specialist.overtime != null && specialist.overtime && !(anytimeWidget && anytimeWidget.meeting)"
                                @click="anytimeMeetingModalOpen"  
                            />

                            <UiButton name="Programează-te" :class="[{'appointments__action': true}]"
                                @click="bookingModalOpen" :disabled="specialist && (!specialist.available)"
                                v-if="user.role === 'client' && specialist && specialist.timetable!=null" />
                            <UiButton name="Programare indisponibilă." :class="[{'appointments__action': true}]"
                                :disabled="true" v-else-if="user.role === 'client' && specialist && specialist.timetable==null" />
                            <UiButton name="Programările sunt disponibile doar pentru clienti."
                                :class="[{'appointments__action': true}]" :disabled="true" v-else />
                        </div>
                        
                    </Card>
                    
                    <div class="spacer" v-if="specialist"></div>
                    <div class="packages" v-dragscroll="!isMobile" v-if="specialist">
                        <Package v-for="(packageItem, i) in packages" :key="i" :name="packageItem.name"
                            :servicePrice="specialist ? specialist.service_price : 0" :appointments="packageItem.services_number"
                            :discount="packageItem.discount" :highlight="packageItem.highlight"
                            :description="packageItem.description" class="packages__item"
                            @choose="choosedPackage = packageItem, $store.state.specialist.modals.buyPackage = true" />
                    </div>
                    <div class="spacer"></div>
                    <Card v-if="user.role=='client' && reviews.canAdd" :title="`Recenzii (${reviews.count})`"
                        action="Adaugă o recenzie" @action="specialist && ($store.state.specialist.modals.addFeedback = true)">
                        <div class="feedback">
                            <div class="feedback__summary">
                                <div class="feedback__grade">{{specialist === null ? '--' : reviews.grade}}</div>
                                <div class="feedback__graph">
                                    <FeedbackStars
                                        v-for="(feedbackRow, i) in 5" :key="i"
                                        :stars="i"
                                        :progress="parseInt(reviews.graph[i])"
                                        :skeleton="specialist === null"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="review-list">
                            <div class="review-list__title">Ultimele Recenzii</div>
                            <p v-if="specialist === null">
                                Recenziile se încarcă...
                            </p>
                            <p v-else-if="reviews.count === 0">
                                Nu există recenzii de afișat.
                            </p>
                            <Review v-for="(review, i) in reviewsDisplay" v-if="review!=null" :key="i"
                                :rating="parseInt(review.stars)" :date="review.created_at"
                                :author="review.client.first_name + (review.client.last_name).charAt(0)" :text="review.description"
                                :approved="review.approved" />
                            <div class="review-list__more" @click="showReviews++"
                                v-if="showReviews*3 < reviews.all.length">
                                Mai multe recenzii...
                            </div>
                        </div>
                    </Card>
                    <Card v-else :title="`Recenzii (${reviews.count})`">
                        <div class="feedback">
                            <div class="feedback__summary">
                                <div class="feedback__grade">
                                    {{specialist === null ? '--' : reviews.grade}}
                                </div>
                                <div class="feedback__graph">
                                    <FeedbackStars
                                        v-for="(feedbackRow, i) in 5"
                                        :key="i" :stars="i"
                                        :progress="parseInt(reviews.graph[i])"
                                        :skeleton="specialist === null"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="review-list">
                            <div class="review-list__title">Ultimele Recenzii</div>
                            <p v-if="specialist === null">
                                Recenziile se încarcă...
                            </p>
                            <p v-else-if="reviews.count === 0">
                                Nu există recenzii de afișat.
                            </p>
                            <Review v-for="(review, i) in reviewsDisplay" v-if="review!=null" :key="i"
                                :rating="parseInt(review.stars)" :date="review.created_at"
                                :author="review.client.first_name + ' ' + (review.client.last_name).charAt(0)" :text="review.description"
                                :approved="review.approved" />
                            <div class="review-list__more" @click="showReviews++"
                                v-if="showReviews*3 < reviews.all.length">
                                Mai multe recenzii...
                            </div>
                        </div>
                    </Card>
                </div>
                <div class="profile-grid__column">
                    <Card title="Programări" class="timetable__desktop" v-if="specialist">
                        <div class="appointments">
                            <div class="appointments__headline">
                                Programări
                            </div>
                            <div class="spacer__line"></div>

                            <UiButton name="Programează-te" :class="[{'appointments__action': true}]"
                                @click="bookingModalOpen" :disabled="specialist && (!specialist.available)"
                                v-if="user.role === 'client' && specialist && specialist.timetable!=null" />
                            <UiButton name="Programare indisponibilă." :class="[{'appointments__action': true}]"
                                :disabled="true" v-else-if="user.role === 'client' && specialist && specialist.timetable==null" />
                            <UiButton name="Programările sunt disponibile doar pentru clienti."
                                :class="[{'appointments__action': true}]" :disabled="true" v-else />
                                
                                                        
                            <UiButton name="Ședință acum" 
                                :disabled="specialist && (!specialist.overtime) || (anytimeWidget && anytimeWidget.meeting)" :anytime="true"
                                v-if="user.role === 'client' && specialist && specialist.overtime != null && specialist.overtime && !(anytimeWidget && anytimeWidget.meeting)"
                                @click="anytimeMeetingModalOpen"
                            /> <!-- [&& specialist.overtime...] was added after in order to hide the button and not just show it as disabled ~RJ 20.09.21-->

                            <div class="appointments__timetable">
                                <div class="appointments__headline">Program de Lucru</div>
                                <div class="spacer__line"></div>
                                <div v-if="specialist && (!specialist.available)"
                                    style="font-size: 13px; line-height: 1.5; text-align: center; margin-top: 20px;">
                                    Programările au fost temporar dezactivate de către specialist.
                                </div>
                                <TimetableDisplay v-else-if="specialist" />
                            </div>
                            <div class="appointments__user-services" v-if="this.userServices.length == 1">
                                <i class="fas fa-info-circle"> </i> Ai <span> o ședință </span> disponibilă la acest
                                specialist.
                            </div>
                            <div class="appointments__user-services" v-if="this.userServices.length > 1">
                                <i class="fas fa-info-circle"> </i> Ai <span> {{this.userServices.length}} ședințe </span>
                                disponibile la acest specialist.
                            </div>
                        </div>
                    </Card>
                    <Card title="Programări" class="timetable__desktop" v-else>
                        <div class="appointments" style="padding-top: 30px;">
                            <div class="skeleton" style="width: 100%; height: 30px;"></div>
                            <div class="skeleton" style="width: 100%; height: 20px; margin-top: 30px;"></div>
                            <div class="skeleton" style="width: 100%; height: 20px; margin-top: 10px;"></div>
                            <div class="skeleton" style="width: 100%; height: 20px; margin-top: 10px;"></div>
                            <div class="skeleton" style="width: 80%; height: 20px; margin-top: 10px;"></div>
                        </div>
                    </Card>
                    <div class="spacer timetable__desktop"></div>
                    {{articles[0]}}
                    <Card :title="`Articole (${articles.count})`" v-if="specialist">
                        <p v-if="articles.count === 0" style="margin-top: 10px;">
                            Nu există articole de afișat.
                        </p>
                        <Article v-for="(article, i) in articles.display" :key="i" :title="article.title"
                            :author="specialist ? specialist.full_name : ''" :date="article.created_at" :imageUrl="article.image_url"
                            @click.native="goToArticle(article.slug)" />
                    </Card>
                </div>
            </div>
        </div>
        <BuyServiceOrPackage
            v-if="$store.state.specialist.modals.buyPackage || $store.state.specialist.modals.buyService"
            :pack="choosedPackage" />

        <AddFeedbackModal v-if="$store.state.specialist.modals.addFeedback" />
        <BookingModal />

        <DescriptionModal v-if="$store.state.specialist.modals.description" />

        <MediaModal v-if="showMediaModal" :videoUrl="specialist && specialist.video_url" @toggleMediaModal="showMediaModal = !showMediaModal" mediaType="embed" :autoplay="false" />
        
        <AnytimeMeetingQueue
            v-if="$store.state.specialist.modals.anytimeMeeting"
        />
        
        <AnytimeMeetingInvite
            v-if="$store.state.specialist.modals.anytimeMeetingInvite.active"
        />
    </div>
</template>

<script>
    import Card from '@/components/ui/Card'
    import Profile from './components/Profile'
    import Package from './components/Package'
    import Review from './components/Review'
    import Article from './components/Article'
    import TimetableDisplay from './components/TimetableDisplay'
    import FeedbackStars from './components/FeedbackStars'
    import UiButton from '@/components/ui/Button'
    import BuyServiceOrPackage from '@/pages/SpecialistPage/components/Buy'
    import AddFeedbackModal from '@/pages/SpecialistPage/components/AddFeedbackModal'
    import BookingModal from '@/pages/SpecialistPage/components/BookingModal'
    import DescriptionModal from '@/pages/SpecialistPage/components/DescriptionModal'
    import MediaModal from '@/components/ui/MediaModal'
    import AnytimeMeetingQueue from '@/pages/SpecialistPage/components/AnytimeMeetingQueue'
    import AnytimeMeetingInvite from '@/pages/SpecialistPage/components/AnytimeMeetingInvite'

    import {
        mapActions
    } from 'vuex'
    import {
        mapGetters
    } from 'vuex'

    export default {
        data() {
            return {
                choosedPackage: null,
                showReviews: 1,
                showMediaModal: false,
                anytimeMeeting: false
            };
        },
        components: {
            BookingModal,
            Card,
            UiButton,
            Profile,
            Package,
            Review,
            Article,
            FeedbackStars,
            TimetableDisplay,
            BuyServiceOrPackage,
            AddFeedbackModal,
            DescriptionModal,
            MediaModal,
            AnytimeMeetingQueue,
            AnytimeMeetingInvite
        },
        methods: {
            ...mapActions({
                fetchSpecialistProfile: 'specialist/specialist'
            }),
            onMount() {
                this.fetchSpecialistProfile(this.$route.params.id);
            },
            goToArticle(slug) {
                this.$router.push(`/articles/${slug}`);
            },
            bookingModalOpen() {
                this.$store.state.specialist.booking.servicesNumber = this.specialist.min_services;
                this.$store.state.specialist.booking.active = true;
                this.$store.state.specialist.booking.specialistId = this.specialist.id;

                // Added by Andrei Preda - for not overlapping booking with other specialist page modals
                this.$store.state.specialist.modals.addFeedback = false;
                this.$store.state.specialist.modals.buyService = false;
                this.$store.state.specialist.modals.buyPackage = false;
                this.$store.state.specialist.modals.moreFeedbacks = false;
                this.$store.state.specialist.modals.description = false;
            },
            anytimeMeetingModalOpen() {
                this.$store.state.specialist.modals.anytimeMeeting = true;
            }
        },
        computed: {
            ...mapGetters({
                specialist: 'specialist/specialist',
                packages: 'specialist/packages',
                reviews: 'specialist/reviews',
                articles: 'specialist/articles',
                user: 'user/user',
                userServices: 'specialist/userServices',
                isMobile: 'layout/isMobile',
                anytimeWidget: 'layout/anytimeWidget'
            }),
            reviewsDisplay() {
                // return this.reviews.all.slice(0, 3*this.showReviews);
                var sliced = [];
                for (let index = 0; index <= 3 * this.showReviews; index++) {
                    sliced[index] = this.reviews.all[index];
                }
                return sliced;
            },
        },
        created() {
            this.onMount();
        },
        watch: {
            '$route.params.id'() {
                this.onMount();
            },
            '$store.state.specialist.specialist': {
                deep: true,
                handler(newSpecialist) {
                    // Subscribe to global specialist channer on selection 
                    // enable / disable anytime button
                    if(newSpecialist) {
                        
                        var queueChannel = newSpecialist.id + '_' + (newSpecialist.full_name).replace(/\s/g, '','') + '_queue';
                                                
                        this.sockets.subscribe(queueChannel, data => {
                            if(data.event == 'unavailable') this.$store.state.specialist.specialist.overtime = false;
                        }); 
                    }
                },
                immediate: false
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "@/scss/pages/profile";
</style>
